import { LodashExtractor, StoreNestedFilterExtractor } from '@ddt-web/data-service';

import { FactMappingInterface } from '../../../../models/fact-mapping.interface';
import { FactExtractor } from '../../fact-extractor';

export const PC_EQUITY_FACTS: { [factName: string]: FactMappingInterface } = {
	numberOfEquityFunds: {
		extractor: new FactExtractor([new LodashExtractor('positionDetails.children')], children => {
			return children.filter(child => child.assetClass === 'Equity' && child.assetType === 'ASSET_TYPE_FUND').length;
		})
	},
	equityPercentage: {
		extractor: new FactExtractor([
			new StoreNestedFilterExtractor(
				['details'],
				'details.portfolioBreakdowns',
				[
					{ propertyToCompare: 'name', comparedValue: 'assetClass', desiredValueExpression: 'sectors' }
				]
			)
		], sectors => {
			return (sectors.find(child => child.name === 'Equity')?.contribution || 0) * 100;
		})
	},
	nonUkEquityPercentage: {
		extractor: new FactExtractor([
			new StoreNestedFilterExtractor(
				['details'],
				'details.sleeves',
				[
					{ propertyToCompare: 'sleeveId', comparedValue: 'equity', desiredValueExpression: 'sleeveAnalysis.portfolioBreakdowns' },
					{ propertyToCompare: 'name', comparedValue: 'region', desiredValueExpression: 'sectors' }

				]
			)
		], sectors => {
			const ukContribution = sectors.find(child => child.name === 'unitedKingdom')?.contribution;
			return (1 - (ukContribution || 0)) * 100;
		})
	},
	emergingMarketsEquityPercentage: {
		extractor: new FactExtractor([
			new StoreNestedFilterExtractor(
				['details'],
				'details.sleeves',
				[
					{ propertyToCompare: 'sleeveId', comparedValue: 'equity', desiredValueExpression: 'sleeveAnalysis.portfolioBreakdowns' },
					{ propertyToCompare: 'name', comparedValue: 'region', desiredValueExpression: 'sectors' }

				]
			)
		], sectors => {
			const emergingMarketsContribution = sectors.find(child => child.name === 'emergingMarkets')?.contribution || 0;
			return emergingMarketsContribution * 100;
		})
	},
	emergingMarketsEquityBenchmarkPercentage: {
		extractor: new FactExtractor([
			new StoreNestedFilterExtractor(
				['details'],
				'details.sleeves',
				[
					{ propertyToCompare: 'sleeveId', comparedValue: 'equity', desiredValueExpression: 'sleeveAnalysis.portfolioBreakdowns' },
					{ propertyToCompare: 'sleeveId', comparedValue: 'region', desiredValueExpression: 'sectors' }

				]
			)], sectors => {
			const emergingMarketsContribution = sectors.find(child => child.name === 'emergingMarkets')?.contribution || 0;
			return emergingMarketsContribution * 100;
		})
	}
};
